import React from 'react';

import InputField from './InputField';
import { validateMinLength, validateMaxLength, validateCustom } from '../validations/validations';

type CustomValidationType = {
    isValid: boolean,
    errorText: string
};

type PropsType = {
    minLength?: number,
    maxLength?: number,
    name: string,
    label: React.ReactNode,
    value: string,
    required?: boolean,
    helperText?: string,
    sx?: {[key: string]: string | number },
    autoComplete?: string,
    autoFocus?: boolean,
    variant?: 'filled' | 'outlined' | 'standard',
    type?: string,
    multiline?: boolean,
    minRows?: number,
    submitOnEnter?: boolean,
    disabled?: boolean,
    customValidations?: CustomValidationType | CustomValidationType[],
    onChange: (a: any) => void
};

export default function TextField(props: PropsType) {
    const {
        minLength,
        maxLength,
        customValidations,
        ...baseProps
    } = props;

    const validations = [];

    if (minLength) {
        validations.push(validateMinLength({ value: baseProps.value, minLength }));
    }

    if (maxLength) {
        validations.push(validateMaxLength({ value: baseProps.value, maxLength }));
    }

    if (customValidations) {
        const customValidationsArray = Array.isArray(customValidations) ? customValidations : [customValidations];
        customValidationsArray.forEach((v) => validations.push(validateCustom(v)));
    }

    return (
        <InputField
            {...baseProps}
            validations={validations}
        />
    );
}
